var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.category && _vm.marketingType)?_c('span',[_vm._v(" "+_vm._s(_vm.categoryMarketingTypeText)+" ")]):(_vm.category)?_c('span',[_vm._v(" "+_vm._s(_vm.$t(_vm.category.text))+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.marketingTypeText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }